function convertStrToBool(value: string) {
  return value === "true" ? true : false;
}

export const helpers = {
  convertStrToBool: convertStrToBool,
};
